import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import {
   getExternalTrainingModulesCurrent,
   GetExternalTrainingModulesCurrentResponse,
} from '~/monolith-api';

const optionsSchema = z.object({
   query: z.string().optional(),
   order: z.enum(['ASC', 'DESC']).optional(),
   offset: z.number().optional(),
   limit: z.number().optional(),
});

export default createBFFHandlers({
   post: async (req, res) => {
      const monolithClient = getServerSideMonolithClient(req);
      const options = optionsSchema.parse(req.body);
      const result = await getExternalTrainingModulesCurrent({
         ...options,
         apiClient: monolithClient,
      });
      res.status(200).json(result);
   },
});

export const getCurrentFromClient = (
   options: GetCurrentExternalTrainingModuleOptions
): Promise<GetCurrentExternalTrainingModulesResult> => {
   return bff()
      .post('/external-training-modules/getCurrent', options)
      .then(response => response.data);
};

export type GetCurrentExternalTrainingModuleOptions = z.infer<typeof optionsSchema>;

export type GetCurrentExternalTrainingModulesResult = GetExternalTrainingModulesCurrentResponse;
